import './bootstrap';
import '../css/app.css';

import {createApp, h} from 'vue';
import {createInertiaApp} from '@inertiajs/vue3';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { setupCalendar } from 'v-calendar';
import {LoadSentry} from "@/sentry.js";
import {LoadPostHog} from "@/posthog.js";
import {HandleErrors} from "@/handleErrors.js";
import {resolveVuePage} from "@/resolveVuePage.client.js";

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolveVuePage(name),
    setup({ el, App, props, plugin }) {
        const app = createApp({
            provide: {
                hasError: false,
            },
            render: () => h(App, props)
        });

        app.use(LoadSentry)
        app.use(LoadPostHog, {
            user: props.initialPage.props.auth?.user ?? null,
            config: props.initialPage.props.posthog ?? null,
        })
        app.use(HandleErrors)
        app.use(plugin);
        app.use(ZiggyVue);
        app.use(setupCalendar, {})
        app.mount(el);

        return app;
    },
    progress: {
        color: '#4B5563',
    },
});

